module.exports = __webpack_public_path__ + "img/17333565.fcf7266e.png";